module.exports = [
	{
		"constant": true,
		"inputs": [
			{
				"name": "_owner",
				"type": "address"
			}
		],
		"name": "name",
		"outputs": [
			{
				"name": "o_name",
				"type": "bytes32"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "owner",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "content",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "addr",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "reserve",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "subRegistrar",
		"outputs": [
			{
				"name": "",
				"type": "address"
			}
		],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_newOwner",
				"type": "address"
			}
		],
		"name": "transfer",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_registrar",
				"type": "address"
			}
		],
		"name": "setSubRegistrar",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [],
		"name": "Registrar",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_a",
				"type": "address"
			},
			{
				"name": "_primary",
				"type": "bool"
			}
		],
		"name": "setAddress",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			},
			{
				"name": "_content",
				"type": "bytes32"
			}
		],
		"name": "setContent",
		"outputs": [],
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "_name",
				"type": "bytes32"
			}
		],
		"name": "disown",
		"outputs": [],
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "_name",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "_winner",
				"type": "address"
			}
		],
		"name": "AuctionEnded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "_name",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "_bidder",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "NewBid",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "name",
				"type": "bytes32"
			}
		],
		"name": "Changed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "name",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "addr",
				"type": "address"
			}
		],
		"name": "PrimaryChanged",
		"type": "event"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/web3/lib/contracts/GlobalRegistrar.json
// module id = 570
// module chunks = 0